import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { Button } from '../../components';
import PeopleAtTable from '../../assets/images/people-at-table.jpg';
import { useHistory } from 'react-router-dom';
import TiltedImageLayout from '../../components/layouts/TiltedImageLayout';

const styles = StyleSheet.create({
  title: {
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'start',
    marginVertical: 20,
  },
  copy: {
    fontSize: 'large',
    lineHeight: 'large',
    maxWidth: 500,
    width: '100%',
  },
});

function MeetPeople() {
  const history = useHistory();
  return (
    <TiltedImageLayout reverse shadow tilt image={PeopleAtTable}>
      <View
        style={{
          alignItems: 'flex-start',
          alignSelf: 'center',
          flex: 1,
          flexBasis: 'auto',
        }}
      >
        <Text style={styles.title}>Triff nette Leute.</Text>
        <Text style={styles.copy}>
          Nimm an einem Treffen teil und erlebe etwas. Lerne ganz ungezwungen
          neue Freunde kennen und verbring ein paar schöne Stunden.
        </Text>
        <Button
          text="Jetzt mitmachen"
          action={() => history.push('/register')}
          size="large"
          style={{ marginVertical: 20 }}
        />
      </View>
    </TiltedImageLayout>
  );
}

export default MeetPeople;
